import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, isRef as _isRef, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "collapse-title" }, " 无票管理-搜索 ", -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "mt-15" }, null, -1)
const _hoisted_5 = { class: "mt-15 mb-15" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("发送提醒")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("确认无票")

import {onMounted, ref} from "vue"
import Api from "@/http/modules/index"
import PaymentModuleUtils from "@/views/typeMapping/PaymentModuleUtils"
import dayjs from "dayjs"
import { ElMessage } from "element-plus"

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let {statusFilter,filterType}=PaymentModuleUtils
let {
  'GET/users/list':userListApi, 
  'GET/pay_pool/drop_list':dropListApi,
  "POST/invoice/no_invoice_conditions":noInvoiceConditionsApi,
  'POST/invoice/send_remind':sendRemindApi,
  // 无票管理_确认无票
  'PATCH/invoice/no_invoice_confirm': no_invoice_confirmApi,

}=Api
let userList=ref<any>([])
let dropListArr: any=ref({})
let activeNames=ref('')
let searchForm=ref<any>({})
let ipagination=ref({
    page:1,
    size:40,
    total:0
})
let selectedList=ref([])
let tableLoading=ref(false)
let tableData=ref([])
let getConditions=()=>{
    let {page,size}=ipagination.value
    let {
        no,approvedRecordId,approvedBy,approvedName,creator,payeeCompany,
        reimburseType,department,payStatus,createTime,payAt, financeApproveStatuses
    }=searchForm.value
    let params={
        page,size,
        query:{
            no,approvedRecordId,approvedBy,approvedName,creator,payeeCompany,reimburseType,department,payStatus,financeApproveStatuses,
            createTime:{
                from:createTime&&createTime.length?new Date(createTime[0]):'',
                to:createTime&&createTime.length?new Date(createTime[1]):'',
            },
            payAt:{
                from:payAt&&payAt.length?new Date(payAt[0]):'',
                to:payAt&&payAt.length?new Date(payAt[1]):'',
            }
        }
    }
    tableLoading.value=true
    noInvoiceConditionsApi(params).then((res:any)=>{
        tableData.value=res.data
        ipagination.value.total=res.rowCount
        tableLoading.value=false
    }).catch(res=>{
        tableLoading.value=false
    })
}
let queryMethod=(operation:string="search")=>{
    if(operation!="search"){
        ipagination.value.page=1
        ipagination.value.size=40
        searchForm.value={}
    }
    getConditions()
}
let defaultTime=ref<[Date,Date]>([new Date(2000, 1, 1, 0, 0, 0),new Date(2000, 2, 1, 23, 59, 59),
])
let sendReminder=()=>{
    console.log(selectedList.value)
    let invoiceIds=selectedList.value.map((el:any)=>el.invoiceId)
    sendRemindApi({invoiceIds}).then(()=>{
        ElMessage.success("提醒成功")
        getConditions()
    })
}
let handleSelectionChange=(val:any)=>{
    selectedList.value=val
} 
let handleSizeChange=(val:number)=>{
    ipagination.value.size=val
    ipagination.value.page=1
    getConditions()
}  
let handleCurrentChange=(val:number)=>{
    ipagination.value.page=val
    getConditions()
}  
onMounted(()=>{
    userListApi().then(res=>userList.value=res)
    dropListApi().then(res=>dropListArr.value=res)
    getConditions()
})


// 确认无票
const confirmNoInvoice = () => {
    if(selectedList.value.length === 0){
        ElMessage.warning('请至少选择一条数据')
        return
    }
    tableLoading.value = true
    no_invoice_confirmApi({
        invoiceIds: selectedList.value.map((e: any) => e.invoiceId)
    }).then(() => {
        ElMessage.success('成功')
        tableLoading.value = false
        getConditions()
    }).catch(() => {
        tableLoading.value = false
    })
}

const checkboxSelect=(row:any,rowIndex:number)=>{
    if(row.status === 'PAYMENT_REISSUED'){
        return false
    }
    return true
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_collapse, {
      accordion: "",
      modelValue: _unref(activeNames),
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_isRef(activeNames) ? (activeNames).value = $event : activeNames = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { name: "1" }, {
          title: _withCtx(() => [
            _hoisted_1
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              ref: "ruleFormRef",
              inline: true,
              model: _unref(searchForm),
              "label-width": 100,
              "label-position": 'left'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { label: "编号" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(searchForm).no,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(searchForm).no) = $event)),
                      style: {"width":"212px"}
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "打包编号" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(searchForm).approvedRecordId,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(searchForm).approvedRecordId) = $event)),
                      style: {"width":"212px"}
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "Hr审批人" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(searchForm).approvedBy,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(searchForm).approvedBy) = $event)),
                      filterable: "",
                      placeholder: "选择一项"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(userList), (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.userId,
                            label: item.alias,
                            value: item.userId
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "发起人" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(searchForm).creator,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(searchForm).creator) = $event)),
                      filterable: "",
                      placeholder: "选择一项"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(userList), (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.userId,
                            label: item.alias,
                            value: item.userId
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "公司" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(searchForm).payeeCompany,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(searchForm).payeeCompany) = $event))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dropListArr).payeeCompanies, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            multiple: "",
                            key: item.id,
                            value: item.id,
                            label: item.name
                          }, null, 8, ["value", "label"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "费用类型" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(searchForm).reimburseType,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(searchForm).reimburseType) = $event))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dropListArr).type, (item, idx) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: idx,
                            label: _unref(filterType)(item),
                            value: item
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "归属部门" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(searchForm).department,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(searchForm).department) = $event))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dropListArr).department, (item, idx) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: idx,
                            label: item,
                            value: item
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "支付状态" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(searchForm).payStatus,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(searchForm).payStatus) = $event))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dropListArr).status, (item, idx) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: idx,
                            value: item,
                            label: _unref(statusFilter)(item)
                          }, null, 8, ["value", "label"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "支付时间" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _unref(searchForm).payAt,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(searchForm).payAt) = $event)),
                      type: "daterange",
                      "range-separator": "To",
                      "start-placeholder": "Start date",
                      "end-placeholder": "End date",
                      "default-time": _unref(defaultTime)
                    }, null, 8, ["modelValue", "default-time"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "创建时间" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _unref(searchForm).createTime,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(searchForm).createTime) = $event)),
                      type: "daterange",
                      "range-separator": "To",
                      "start-placeholder": "Start date",
                      "end-placeholder": "End date",
                      "default-time": _unref(defaultTime)
                    }, null, 8, ["modelValue", "default-time"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "财务审核状态" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(searchForm).financeApproveStatuses,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(searchForm).financeApproveStatuses) = $event)),
                      clearable: "",
                      placeholder: "请选择一项"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "未审核",
                          value: "APPROVE_SEC"
                        }),
                        _createVNode(_component_el_option, {
                          label: "已审核",
                          value: "APPROVE_SUCCESS"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"]),
            _createVNode(_component_el_space, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_unref(queryMethod)('search')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_unref(queryMethod)('reset')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_el_button, {
        type: "primary",
        disabled: !_unref(selectedList).length,
        onClick: _unref(sendReminder)
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["disabled", "onClick"]),
      _createVNode(_component_el_button, {
        onClick: _cache[14] || (_cache[14] = ($event: any) => (confirmNoInvoice()))
      }, {
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      })
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref: "tableRef",
      onSelectionChange: _unref(handleSelectionChange),
      data: _unref(tableData),
      border: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "selection",
          width: "55",
          selectable: checkboxSelect
        }),
        _createVNode(_component_el_table_column, {
          prop: "no",
          label: "编号",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          prop: "approvedRecordId",
          label: "打包编号",
          width: "100",
          formatter: (row) => 'DB' + row.approvedRecordId
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          prop: "creator",
          label: "发起人",
          width: "150"
        }),
        _createVNode(_component_el_table_column, {
          prop: "payeeCompany",
          label: "公司",
          width: "200",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          prop: "department",
          label: "归属部门",
          width: "150"
        }),
        _createVNode(_component_el_table_column, {
          prop: "approvedName",
          label: "HR审批人",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          prop: "note",
          label: "摘要",
          width: "200",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          prop: "estimateAmount",
          label: "申请金额",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          prop: "totalAmount",
          label: "无票金额",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          prop: "approvedStatus",
          label: "财务审批状态",
          width: "120"
        }, {
          default: _withCtx(({row}) => [
            _createTextVNode(_toDisplayString(_unref(statusFilter)(row.approvedStatus)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "status",
          label: "支付状态",
          width: "100",
          formatter: (row) => _unref(statusFilter)(row.status)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          prop: "payAt",
          label: "支付时间",
          width: "150"
        }, {
          default: _withCtx(({row}) => [
            _createTextVNode(_toDisplayString(row.payAt?_unref(dayjs)(row.payAt).format("YYYY-MM-DD"):''), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "type",
          label: "费用类型",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          prop: "remindNum",
          label: "提醒次数",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          prop: "lastRemindAt",
          label: "末次提醒时间",
          width: "150"
        }, {
          default: _withCtx(({row}) => [
            _createTextVNode(_toDisplayString(row.lastRemindAt?_unref(dayjs)(row.lastRemindAt).format("YYYY-MM-DD"):''), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["onSelectionChange", "data"])), [
      [_directive_loading, _unref(tableLoading)]
    ]),
    _createVNode(_component_el_pagination, {
      currentPage: _unref(ipagination).page,
      "onUpdate:currentPage": _cache[15] || (_cache[15] = ($event: any) => ((_unref(ipagination).page) = $event)),
      "page-size": _unref(ipagination).size,
      "onUpdate:page-size": _cache[16] || (_cache[16] = ($event: any) => ((_unref(ipagination).size) = $event)),
      "page-sizes": [1, 40, 80, 120],
      layout: "prev,pager,next,sizes,total",
      total: _unref(ipagination).total,
      onSizeChange: _unref(handleSizeChange),
      onCurrentChange: _unref(handleCurrentChange)
    }, null, 8, ["currentPage", "page-size", "total", "onSizeChange", "onCurrentChange"])
  ], 64))
}
}

})